import { CheckCheck, ClipboardCheck, Eye, FileText, MoreHorizontal, Undo2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { toast } from 'sonner'
import { useAuth } from '@/lib/auth/AuthProvider'
import { apiErrorMessage } from '@/i18n'
import { useSetBordroDurum } from '../../api'
import { printBordro } from '../../lib/bordroActions'
import type { BordroDurum, BordroSatir } from '../../types'
import { HR_PAYROLL_WRITE_PERM } from '../../../permissions'

export function BordroRowActions({ row, donem, onSummary }: { row: BordroSatir; donem: string; onSummary: () => void }) {
  const { t } = useTranslation()
  const { can } = useAuth()
  const change = useSetBordroDurum()
  const setDurum = (durum: BordroDurum) =>
    change.mutate(
      { row, durum },
      {
        onSuccess: () => toast.success(t('hr.personel.actions.bordro.statusChanged', { name: row.ad, durum: t(`hr.personel.bordro.durum.${durum}`) })),
        onError: (e) => toast.error(apiErrorMessage(e)),
      },
    )
  const editable = can(HR_PAYROLL_WRITE_PERM) && !row.blokeNedeni && !change.isPending
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="size-8 text-muted-foreground data-[state=open]:bg-muted data-[state=open]:text-foreground"
          aria-label={t('hr.personel.columns.islem')}
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-xl" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem onSelect={onSummary}>
          <Eye />
          {t('hr.personel.actions.bordro.summary')}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => void printBordro(row, donem)}>
          <FileText />
          {t('hr.personel.actions.bordro.pdf')}
        </DropdownMenuItem>
        {row.blokeNedeni ? <div className="px-2 py-1.5 text-xs text-muted-foreground">{row.blokeNedeni}</div> : null}
        {editable ? (
          <>
            <DropdownMenuSeparator />
            {row.durum === 'taslak' ? (
              <DropdownMenuItem onSelect={() => setDurum('kontrol')}>
                <ClipboardCheck />
                {t('hr.personel.actions.bordro.markKontrol')}
              </DropdownMenuItem>
            ) : null}
            {row.durum === 'kontrol' ? (
              <DropdownMenuItem onSelect={() => setDurum('onay')}>
                <CheckCheck />
                {t('hr.personel.actions.bordro.approve')}
              </DropdownMenuItem>
            ) : null}
            {row.durum !== 'taslak' ? (
              <DropdownMenuItem onSelect={() => setDurum('taslak')}>
                <Undo2 />
                {t('hr.personel.actions.bordro.revert')}
              </DropdownMenuItem>
            ) : null}
          </>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
